const e = {
  personalizationRules: ["personalization-rules"],
  messages: ["messages"],
  messageThread: (s) => [...e.messages, "thread", s],
  unreadMessagesCount: () => [...e.messages, "unread"],
  messagesFilterType: (s) => [
    ...e.messages,
    s
  ]
};
export {
  e as q
};
